export const template = document.createElement('template');

import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
import { styles as flexBoxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';

template.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>

  <div class='d-flex wrapper'>
    <gz-text fontSize='12' class='mt-1 subform-section-label' id='rules-actions-label' style='width:250px'></gz-text>
    <div class='subform-section-fields' id='rules-actions-container'></div>
  </div>
`;
